import React, { useState, useEffect, MouseEvent, FunctionComponent } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import ViewProps from '../types/ViewProps'
import HelperParams from '../types/HelperParams'

export default ({ appState, setAppState, data }: ViewProps) => {

  const [ navigating, setNavigating ] = useState<boolean>(false)
  const [ generating, setGenerating ] = useState<boolean>(false)
  let { question } = useParams<HelperParams>()
  question = typeof question === 'undefined' ? 'landing' : question

  const q = data!.find(q => q.id === question)
  const View = q!.component

  let history = useHistory()

  let width = window.innerWidth
  let height = window.innerHeight

  useEffect(() => {
    document.title = `${q!.pageTitle} | Application Helper | Emily Carr University of Art + Design`
  })

  const handleClick = (event: MouseEvent): void => {
    // if (appState[question] === ' ' || (Array.isArray(appState[question]) && (appState[question] as Array<string>).length == 0))

    setNavigating(true)
    
    setTimeout(() => {
      if (appState.citizenship !== 'Yes' && appState.citizenship !== 'United States' && appState.next === 'indigenous') {
        history.push(`/language`)
      }
      else if (appState.next === 'continuingStudies') {
        window.location.href = `https://www.ecuad.ca/academics/continuing-studies`
      }
      else if (appState.next === 'checklist') {
        setGenerating(true)
        setTimeout(() => {
          history.push(`/checklist`)
        }, 400)
      }
      else {
        history.push(`/${appState.next}`)
      }

      setNavigating(false)
    }, 300)
  }

  return (
    <div className={`helper-wrapper questions ${question}`}>
      <div className={`helper-content-wrapper ${generating ? 'finished' : ''}`}>
        <div className={`helper-content ${navigating ? 'navigating' : ''}`}>
          <View data={data} appState={appState} setAppState={setAppState} path={question} handleClick={handleClick} />
        </div>
      </div>

      <div className={"shape"} id={"pie"} style={{ transform: `translate(${q!.shapes.pie.x}vw, ${q!.shapes.pie.y}vh) rotate(${q!.shapes.pie.rotate}deg)`}}></div>
      <div className={"shape"} id={"macaroni"} style={{ transform: `translate(${q!.shapes.macaroni.x}vw, ${q!.shapes.macaroni.y}vh) rotate(${q!.shapes.macaroni.rotate}deg)`}}></div>
      <div className={"shape"} id={"gridcircle"} style={{ transform: `translate(${q!.shapes.gridcircle.x}vw, ${q!.shapes.gridcircle.y}vh) rotate(${q!.shapes.gridcircle.rotate}deg)` }}></div>
      <div className={"shape"} id={"gridsquare"} style={{ transform: `translate(${q!.shapes.gridsquare.x}vw, ${q!.shapes.gridsquare.y}vh) rotate(${q!.shapes.gridsquare.rotate}deg)` }}></div>
      <div className={"shape"} id={"circle"} style={{ transform: `translate(${q!.shapes.circle.x!}vw, ${q!.shapes.circle.y}vh) rotate(${q!.shapes.circle.rotate}deg)` }}></div>
      <div className={"shape"} id={"halfcircle"} style={{ transform: `translate(${q!.shapes.halfcircle.x}vw, ${q!.shapes.halfcircle.y}vh) rotate(${q!.shapes.halfcircle.rotate}deg)` }}></div>
      <div className={"shape"} id={"square"} style={{ transform: `translate(${q!.shapes.square.x}vw, ${q!.shapes.square.y}vh) rotate(${q!.shapes.square.rotate}deg)` }}></div>

      <div className={`after-layer after-layer-to`}></div>
      <div className={`after-layer after-layer-from`}></div>
    </div>
  )
}